import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { FeedbackStudentsPreviewModel } from "common/models/page-models/Feedback students preview/feedback-students-preview-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { TokenService } from "common/services/core-services/get-token.service";


@Injectable({
    providedIn: 'root'
})
export class FeedbackStudentFormDataService extends FormDataService<FeedbackStudentsPreviewModel> {
    constructor(http: SmApiService, protected override ss: SystemService, private tokenService: TokenService) {
        super(API_URL.studentFeedbackSubmit, http, ss);
    }
    
    getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.feedbackStudentsGrid,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        let payload;
        payload = {
            id: data.transferData.feedback_Form_Id,
            feedback_form_mapping_id: data.transferData.feedback_form_mapping_id
            // feedbackFormId: data.transferData.feedbackFormId,
            // feedbackFormMappingId: data.transferData.feedbackFormMappingId,

        }
        return payload;
    }


    createInstance(): FeedbackStudentsPreviewModel {
        
        return new FeedbackStudentsPreviewModel();
    }

    override modifyAPIResponse(response: any) {
        // console.log(response['details']);
        const modifiedResponse = response['details'].questions.sort((a, b) => a.id - b.id);
        // console.log(response['details']);
        return response['details'];
        
    }
    override modifyPostModel(formModel: any, dataModel: any) {
        return formModel;
    }

    // override modifyModel(model, metamodel = null) {
    //     console.log(model)


    //     // model['student_id'] = JSON.parse(this.systemService.getlocalStorage('profile')).id;
    //     const transformedPayload = {
    //         student_id: model['student_id'],
    //         feedback_form_id: model['feedbackFormId'],
    //         feedback_form_mapping_id: model['feedbackFormMappingId'],
    //         feedbackQuestionResponse: []
    //     };

    //     for (const key in model) {
    //         if (model.hasOwnProperty(key) && key !== 'student_id' && key !== 'feedbackFormMappingId' && key !== 'feedbackFormId') {
    //             transformedPayload.feedbackQuestionResponse.push({
    //                 questionId: parseInt(key, 10),
    //                 answer: model[key]
    //             });
    //         }
    //     }

    //     console.log(transformedPayload);
    //     return transformedPayload;
    // }

    // convertToFormData(payload) {
    //     const formData = new FormData();

    //     // Append fixed values
    //     formData.append('student_id', payload.student_id);
    //     formData.append('feedbackFormId', payload.feedbackFormId);
    //     formData.append('feedbackFormMappingId', payload.feedbackFormMappingId);

    //     // Append feedback question responses
    //     payload.feedbackQuestionResponse.forEach((response, index) => {
    //         formData.append(`feedbackQuestionResponse[${index}][questionId]`, response.questionId);
    //         formData.append(`feedbackQuestionResponse[${index}][answer]`, response.answer);
    //     });

    //     return formData;
    // }

    override getPostDataType() {
        return false;
    }

    override getUpdateUrl() {
        return '';
    }

    override beforePostData(
        model: any,
        metamodel: any,
        dataModel: any
    ): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const transformedPayload = {
                student_id: dataModel.student_id,
                feedback_Form_Id: model['feedbackFormId'],
                feedback_form_mapping_id: model['feedbackFormMappingId'],
                feedbackQuestionResponse: []
            };
            // console.log(transformedPayload.feedbackQuestionResponse);
            
            for (const key in model) {
                // console.log(model);

                if (model.hasOwnProperty(key) && key !== 'student_id' && key !== 'feedbackFormMappingId' && key !== 'feedbackFormId') {
                    // console.log(model[key]);

                    transformedPayload.feedbackQuestionResponse.push({
                        questionId: parseInt(key, 10),
                        answer: Array.isArray(model[key]) ? model[key].join(', ') : String(model[key])
                    });
                    // console.log(transformedPayload.feedbackQuestionResponse);
                }
            }
            resolve(transformedPayload);
        });
    }



}